let getStartedBtn = document.querySelector(".getstarted--btn");
let step1nextBtn = document.querySelector(".first--btn");
let step2nextBtn = document.querySelector(".second--btn");
let step3nextBtn = document.querySelector(".third--btn");
let imageCheckBtn = document.querySelector('.image-check-btn')
let step2backBtn = document.querySelector(".button-back2");
const getStartedDiv = document.querySelector(".getStarted-part-wrapper");
const step1Div = document.querySelector(".first-part-wrapper");
const step2Div = document.querySelector(".second-part-wrapper");
const step3Div = document.querySelector(".third-part-wrapper");
const step4Div = document.querySelector(".fourth-part-wrapper");
const thankyouSection = document.querySelector(".thankyou--section");
let step3backBtn = document.querySelector(".button-back3");
const progressItems = document.querySelectorAll(".progressBar li");
const showdropDownButton = document.querySelector(".showdropdown");
const citiesSelect = document.querySelector(".cities-dropdown");
// new line
const imageInput = document.getElementById("uploadImage");


// New code
// function insertDummyImageFile() {
//   const dummyImageFile = new File(["dummy content"], "no-image.jpg", { type: "image/jpeg" });

//   const dataTransfer = new DataTransfer();
//   dataTransfer.items.add(dummyImageFile);

//   const fileInput = document.getElementById("uploadImage");
//   fileInput.files = dataTransfer.files;
// }


async function insertDummyImageFile() {
  const imageUrl = "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"; // fallback image URL

  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    const imageFile = new File([blob], "no-image.jpg", { type: blob.type });

    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(imageFile);

    imageInput.files = dataTransfer.files;

    console.log("Fallback image inserted automatically.");
  } catch (error) {
    console.error("Failed to insert fallback image:", error);
  }
}

function checkAndInsertFallback() {
  if (imageInput.files.length === 0) {
    insertDummyImageFile();
  }
}


// New Code


function showSection(show, hide) {
  show.classList.remove("hidden");
  hide.classList.add("hidden");
  window.scrollTo({ top: 0, behavior: "smooth" });
}

function showError(element, message) {
  element.innerText = message || "";
}

progressItems.forEach((item, index) => {
  if (!step2Div.classList.contains("hidden")) {
    if (index === 1) {
      item.classList.add("activeProgress");
    } else if (index === 0) {
      item.classList.add("previoulsyProgress");
    } else {
      item.classList.add("inActiveProgress");
    }
  }

  // commented section
  // if (!step3Div.classList.contains("hidden")) {
  //   if (index === 1) {
  //     item.classList.add("previoulsyProgress");
  //   } else if (index === 0) {
  //     item.classList.add("previoulsyProgress");
  //   } else {
  //     item.classList.add("activeProgress");
  //   }
  // }
});

$("#result-arrow-icon").click(function (event) {
  $("#result_section").removeClass("hidden");
  console.log("clicked");
  $("html,body").animate({
    scrollTop: $("#result_section").offset().top,
  });
});

const getIpAddress = async()=>{
     try {
               const response = await fetch('https://api.ipify.org?format=json');
               const data = await response.json();
               return data.ip;

           } catch (error) {
               console.error('Error fetching IP address:', error);
       return null
           }
}

// getStarted button

getStartedBtn.addEventListener("click", async function (e) {
  e.preventDefault();
   let isEnable = window.isEnable

      let ipAddress = await getIpAddress()
  let url = 'https://defend-backend-integration-icd1.onrender.com/api/v1/report/ip-setting'
     showSection(step1Div, getStartedDiv);
  $(".result-page").addClass("hidden");
  fetch(url, {
  method: 'POST', 
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({ ipAddress,isEnable }) 
})
.then(response => response.json())
.then(data => {
  console.log(data,"data")
  console.log(data?.success,"success")
  if(data?.success===false){
    step1Div.classList.add("hidden")
    $('.content-validity').removeClass("hidden")
  }

})
.catch(error => {
  console.error('Error:', error);
});
       

});

// step 1 next button click \  age div
step1nextBtn.addEventListener("click", function (e) {
  e.preventDefault();
  const errordiv = document.querySelector(".age-field-error");
  const ageValue = document.querySelectorAll(".input-age");
  let ageSelected = false;
  ageValue.forEach((item) => {
    if (item.checked) {
      ageSelected = true;
    }
  });
  if (!ageSelected) {
    showError(errordiv, "Age is Required");
  } else {
    showError(errordiv, "");
    showSection(step2Div, step1Div);
  }
});



// commented section
// imageCheckBtn.addEventListener("click",(e)=>{
//   e.preventDefault()
//   const errorDiv = document.querySelector(".image-error-div")
//   const imageFile = document.getElementById("uploadImage").files[0]
//   if(!imageFile){ 
//   errorDiv.classList.remove("hidden")
//   showError(errorDiv,"This field is required")
//     setTimeout(()=>{
//        errorDiv.classList.add("hidden")
//     },2000)
//   }else{ 
//    showSection(step4Div, step3Div);
//   }
// })

document.querySelectorAll(".input-age").forEach((item) => {
  item.addEventListener("change", () => {
    const errordiv = document.querySelector(".age-field-error");
    showError(errordiv, "");
  });
});

// for medication/drugs

step2nextBtn.addEventListener("click", function (e) {
  e.preventDefault();
  const medication = document.querySelector(".select-medication").value;
  const errordiv = document.querySelector(".select-error");
  if (medication === "" || medication === null) {
    showError(errordiv, "Medication is required");
  } else {
    // commented section
    // showSection(step3Div, step2Div);
    // new line
   const imageInput = document.getElementById("uploadImage");
  // if (imageInput.files.length === 0) {
  //   insertDummyImageFile(); // Inject fake image
  // }


    if (imageInput.files.length === 0) {
   
    insertDummyImageFile()
  }
    
    // new line
    showSection(step4Div, step2Div);
  }
});
document.querySelector(".select-medication").addEventListener("change", () => {
  const errordiv = document.querySelector(".select-error");
  showError(errordiv, "");
});

// location step
step3nextBtn.addEventListener("click", function (e) {
  // $(".result-page").addClass("hidden");
  const StateValue = document.querySelector(".select-state").value;
  const CitiesValue = document.querySelector(".cities").value;
  const errordiv = document.querySelector(".address-error");
  if (StateValue === null || StateValue === "") {
    e.preventDefault();
    showError(errordiv, "State and City is required");
  } else if (CitiesValue === null || CitiesValue === "") {
    e.preventDefault();
    showError(errordiv, "City is required");
  }
    // uncommented section
  else {
    showSection(thankyouSection, step3Div);
  }
});
document.querySelector(".select-state").addEventListener("change", () => {
  const errordiv = document.querySelector(".address-error");
  showError(errordiv, "");
});

document.querySelector(".cities").addEventListener("change", () => {
  const errordiv = document.querySelector(".address-error");
  showError(errordiv, "");
});

//back button for step 2 // back button for medication
// step2backBtn.addEventListener("click", function (e) {
//   e.preventDefault();
//   showSection(step1Div, step2Div);
// });

// back button for step-3 // back button for location
// step3backBtn.addEventListener("click", function (e) {
//   e.preventDefault();
//     showSection(step2Div, step3Div);
// });

document.querySelector(".data_info").addEventListener("click", (e) => {
  $(".result-page").removeClass("hidden");
});

$(document).ready(function () {
  // Handle change event for all dropdowns with the class 'dropdowns cities'
  $(".dropdowns.cities").on("change", function () {
    // Get the selected value from the changed dropdown
    var selectedValue = $(this).val();

    // Set the value of the input field with the selected value
    $("#city").val(selectedValue);
  });
  // $('a[href="#result_section"]').on("click", function (event) {
  //     $(this).trigger('dblclick');
  //   event.preventDefault(); // Prevent the default anchor behavior
  //   $("html, body").animate(
  //     {
  //       scrollTop: $("#result_section").offset().top,
  //     },
  //     1000
  //   ); // 1000 milliseconds is the speed of the scrolling
  // });
});
